var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricing3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#A854F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1251 6.875V7.55313L6.76258 8.70937C6.61698 8.736 6.48556 8.81343 6.39171 8.92788C6.29786 9.04234 6.24767 9.18638 6.25008 9.33437V10.6906C6.24767 10.8386 6.29786 10.9827 6.39171 11.0971C6.48556 11.2116 6.61698 11.289 6.76258 11.3156L7.50008 11.425V12.5C7.50008 12.6658 7.56593 12.8247 7.68314 12.9419C7.80035 13.0592 7.95932 13.125 8.12508 13.125H10.6251C10.7908 13.125 10.9498 13.0592 11.067 12.9419C11.1842 12.8247 11.2501 12.6658 11.2501 12.5V12.1062L13.1251 12.4469V13.125H13.7501V6.875H13.1251ZM10.6251 12.5H8.12508V11.5406L10.6251 11.9937V12.5ZM6.87508 10.6781V9.32188L13.1251 8.1875V11.8125L6.87508 10.6781Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing3);
export default __webpack_public_path__ + "static/media/pricing 3.cde9f3fb05d4a55a906ebb2b2ea8175b.svg";
export { ForwardRef as ReactComponent };